import _ from "lodash";
import ACTIONS from "../actions/supportActions";

const initialState = {
    regions: [
        {label: "Virginia (US)", value: "us-east-1"},
        {label: "Frankfurt (EU)", value: "eu-central-1"},
        {label: "London (EU)", value: "eu-west-2"},
        {label: "Mumbai (AP)", value: "ap-south-1"},
    ],
    regionOptions: [],
    regionValue: null,
    htmlString: "",
    jsonString: "",
    txModalOpen: false,
    hasDebugFiles: false,
    debugModalOpen: false,
    wsid: "",
    wsidNotFound: null,
}

const txDebugLogsReducer = (state = initialState, action) => {
    switch (action.type) {

        case ACTIONS.SupportActionTypes.ENTER_WSID: {
            let newState = _.cloneDeep(state);
            newState.wsid = action.payload.wsid;
            return newState;
        }

        case ACTIONS.SupportActionTypes.REGION_SELECTED: {
            let newState = _.cloneDeep(state);
            newState.regionValue = action.payload.selectedOption;
            return newState;
        }

        case ACTIONS.SupportActionTypes.LOAD_TX_LOGS: {
            let newState = _.cloneDeep(state);
            newState.jsonString = action.payload.txLogs;
            newState.txModalOpen = true;
            return newState;
        }

        case ACTIONS.SupportActionTypes.LOAD_DEBUG_FILES: {
            let newState = _.cloneDeep(state);
            newState.htmlString = action.payload.debugFiles;
            newState.hasDebugFiles = !!newState.htmlString;
            return newState;
        }

        case ACTIONS.SupportActionTypes.DISPLAY_DEBUG_FILES: {
            let newState = _.cloneDeep(state);
            newState.debugModalOpen = true;
            return newState;
        }

        case ACTIONS.SupportActionTypes.CLOSE_TX_MODAL: {
            let newState = _.cloneDeep(state);
            newState.txModalOpen = false;
            newState.hasDebugFiles = false;
            return newState;
        }

        case ACTIONS.SupportActionTypes.CLOSE_DEBUG_MODAL: {
            let newState = _.cloneDeep(state);
            newState.debugModalOpen = false;
            return newState;
        }

        case ACTIONS.SupportActionTypes.CLEAR_TX_DEBUG_DETAILS: {
            return initialState;
        }

        default:
            return state;
    }
}

export default txDebugLogsReducer;
